import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/adquisiciones/devoluciones/{id}', documento: 'adquisiciones', acceso: 'sesion', filas: ['054'],
  cita: 'Areas/Adquisiciones/Controllers/DevolucionesController.cs',
} satisfies RutaProd;
